// roleLabel — the ONE way a role slug is named on screen (issue 728): a known
// slug renders its catalogue label in the active locale, anything else the
// slug in sentence case — never the slug itself (`hq_admin`) and never a
// naive title-case of it ("Hq admin"). The company chooser calls it directly;
// every surface that also holds the company's role list goes through
// roleName() (components/admin/vocab.ts), which lets an AUTHORED name win and
// then falls back to this.
//
// First-load code (the chooser is in the entry chunk), so it stays this small:
// six eager catalogue keys and no catalogue import. t() of a key no catalogue
// holds resolves undefined (i18n/index.ts → entry), which is the "not a known
// slug" signal; roleLabel.test.ts pins that, so a t() that ever started
// returning the key would fail there rather than show `role.x` on screen.
import { t, type StringKey } from '../i18n';

export function roleLabel(slug: string): string {
  const known = t(`role.${slug}` as StringKey) as string | undefined;
  if (known) return known;
  const spaced = slug.replace(/_/g, ' ').trim();
  return spaced ? spaced.charAt(0).toUpperCase() + spaced.slice(1) : slug;
}
